import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

//components//
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import SwitchWidget from '../SwitchWidget';


class WorklogValidation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationSettings: {
                scheduleNotifications: false,
                timeSheetNotifications: false,
                absenceNotifications: false,
                vacationNotifications: false,
                userInviteEmailWhileImporting: true
            }
        }
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillMount() {
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        const { notificationSettings } = this.state;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            if (basicRules.notificationSettings) {
                // notificationSettings.scheduleNotifications = basicRules.notificationSettings.scheduleNotifications;
                // notificationSettings.timeSheetNotifications = basicRules.notificationSettings.timeSheetNotifications;
                // notificationSettings.absenceNotifications = basicRules.notificationSettings.absenceNotifications;
                // notificationSettings.vacationNotifications = basicRules.notificationSettings.vacationNotifications;
                notificationSettings.userInviteEmailWhileImporting = basicRules.notificationSettings.userInviteEmailWhileImporting ?? notificationSettings.userInviteEmailWhileImporting;
                this.setState({ notificationSettings })
            }
        }
    }

    handleTextChange = (name, value) => {
        const { notificationSettings } = this.state;
        notificationSettings[name] = value;
        this.props.handleUserDataChange('notificationSettings', notificationSettings);
        this.setState({ notificationSettings });
    }

    handleCheck = (name, evt) => {
        const { notificationSettings } = this.state;
        notificationSettings[name] = evt;
        this.props.handleUserDataChange('notificationSettings', notificationSettings);
        this.setState({ notificationSettings });
    }

    render() {
        const { notificationSettings } = this.state;
        const { t } = this.props;
        return (
            <div>
                {/* <Row>
                    <Col sm={1}>
                        <SwitchWidget
                            value={notificationSettings.scheduleNotifications}
                            onChange={checked => this.handleCheck('scheduleNotifications', checked)} />
                    </Col>
                    <Col sm={11} className='d-flex'>
                        <label className="control-label">{t('Schedule notifications')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="scheduleNotifications"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("When enabled, members and PMs will receive notifications whenever a new schedule is created or shifts are swapped.")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col sm={1}>
                        <SwitchWidget
                            value={notificationSettings.timeSheetNotifications}
                            onChange={checked => this.handleCheck('timeSheetNotifications', checked)} />
                    </Col>
                    <Col sm={11} className='d-flex'>
                        <label className="control-label">{t('Timesheet notifications')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="timeSheetNotifications"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("When enabled, members and PMs will be notified whenever a timesheet is approved or an automatic logout occurs.")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col sm={1}>
                        <SwitchWidget
                            value={notificationSettings.absenceNotifications}
                            onChange={checked => this.handleCheck('absenceNotifications', checked)} />
                    </Col>
                    <Col sm={11} className='d-flex'>
                        <label className="control-label">{t('Absence notifications')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="absenceNotifications"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("When enabled, members and PMs will receive notifications whenever a new absence request is created or an absence request is approved.")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col sm={1}>
                        <SwitchWidget
                            value={notificationSettings.vacationNotifications}
                            onChange={checked => this.handleCheck('vacationNotifications', checked)} />
                    </Col>
                    <Col sm={11} className='d-flex'>
                        <label className="control-label">{t('Vacation notifications')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="vacationNotifications"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("When enabled, members and PMs will receive notifications whenever a new vacation request is created or a vacation request is approved.")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row> */}
                <Row className="mt-3">
                    <Col sm={1}>
                        <SwitchWidget
                            value={notificationSettings.userInviteEmailWhileImporting}
                            onChange={checked => this.handleCheck('userInviteEmailWhileImporting', checked)} />
                    </Col>
                    <Col sm={11} className='d-flex'>
                        <label className="control-label">{t('Send Email invite when importing users')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="userInviteEmailWhileImporting"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("If Enabled, System will send the email invite to users who directly importing through the integrations")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(WorklogValidation))));
